import React from 'react'
import Hotitemcard from './Hotitemcard';
import '../../styles/HotAccessories.css';

const Music = ({hotAccessoriesCover,hotAccessories}) => {
    console.log("Music",hotAccessoriesCover['music']);
    console.log("Music data",hotAccessories['music']);
    return (
        <>
        <div className="HotAccessories">
                <div>
                    <img src={hotAccessoriesCover['music']} alt={`${'index'} offer`}></img>
                </div>    

                <div>
                  {
                      hotAccessories['music'].map((item,index)=>{
                          return(
                              <Hotitemcard key={item.image} name={item.name} prize={item.price} image={item.image} index={index}></Hotitemcard>
                          )
                      })
                  }
                </div>

                

           </div>
        </>
    )
}

export default Music
